import * as yup from 'yup'

import constants from 'constants/index'

const schema = () =>
  yup.object().shape({
    formType: yup
      .string()
      .required('É preciso selecionar um tipo de formulário'),
    otherCommitteesSelect: yup.string().when('formType', {
      is: constants.committees.FORM_OTHER_COMMITTEE,
      then: yup.string().required('É preciso selecionar um comitê'),
    }),
    anotherCommitteeCategory: yup.string().when('otherCommitteesSelect', {
      is: constants.committees.ANOTHER_COMMITTEE_CATEGORY_VALUE,
      then: yup
        .string()
        .trim()
        .required('É preciso informar o nome do comitê')
        .test(
          'not-generic-outros',
          'Informe um nome específico, não use apenas "Outros"',
          (value) => value?.trim().toLowerCase() !== 'outros',
        ),
    }),
  })

export default schema
